/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitialCreditResponse
 */
export interface InitialCreditResponse {
    /**
     * When set to true, the user will not be required to spend their initial credits within the expiration period.
     * @type {boolean}
     * @memberof InitialCreditResponse
     */
    expirationBypassed?: boolean;
    /**
     * Whether the workspace's owner is eligible for an extension
     * @type {boolean}
     * @memberof InitialCreditResponse
     */
    eligibleForExtension?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InitialCreditResponse
     */
    exhausted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InitialCreditResponse
     */
    expirationEpochMillis?: number;
    /**
     * 
     * @type {number}
     * @memberof InitialCreditResponse
     */
    extensionEpochMillis?: number;
    /**
     * The current balance of initial credits for the workspace
     * @type {number}
     * @memberof InitialCreditResponse
     */
    balance?: number;
}

/**
 * Check if a given object implements the InitialCreditResponse interface.
 */
export function instanceOfInitialCreditResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InitialCreditResponseFromJSON(json: any): InitialCreditResponse {
    return InitialCreditResponseFromJSONTyped(json, false);
}

export function InitialCreditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitialCreditResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expirationBypassed': !exists(json, 'expirationBypassed') ? undefined : json['expirationBypassed'],
        'eligibleForExtension': !exists(json, 'eligibleForExtension') ? undefined : json['eligibleForExtension'],
        'exhausted': !exists(json, 'exhausted') ? undefined : json['exhausted'],
        'expirationEpochMillis': !exists(json, 'expirationEpochMillis') ? undefined : json['expirationEpochMillis'],
        'extensionEpochMillis': !exists(json, 'extensionEpochMillis') ? undefined : json['extensionEpochMillis'],
        'balance': !exists(json, 'balance') ? undefined : json['balance'],
    };
}

export function InitialCreditResponseToJSON(value?: InitialCreditResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expirationBypassed': value.expirationBypassed,
        'eligibleForExtension': value.eligibleForExtension,
        'exhausted': value.exhausted,
        'expirationEpochMillis': value.expirationEpochMillis,
        'extensionEpochMillis': value.extensionEpochMillis,
        'balance': value.balance,
    };
}

